import { render, staticRenderFns } from "./AddressStepComponent.vue?vue&type=template&id=6fe5a8e8&scoped=true"
import script from "./AddressStepComponent.vue?vue&type=script&lang=js"
export * from "./AddressStepComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe5a8e8",
  null
  
)

export default component.exports